module.exports = __webpack_public_path__ + "GooglePixel3-White@2x.png?fc57c44f4fa831dc5f0cad2fa146cb2e";